<template>
  <div>
    <Row :gutter="8" class="m-b-10">
      <i-col span="6">
        <i-input v-model="query.keyWord" clearable size="small" placeholder="关键字：电费收款单名称"></i-input>
      </i-col>
      <i-col span="18">
        <Button type="primary" icon="ios-search" size="small" @click="handleSearch">搜索</Button>
        <i-button type="success" class="m-l-10" size="small" @click="handleCreate">新建收款单</i-button>
      </i-col>
    </Row>
    <Table stripe size="small" :data="tableData" :columns="tableColumns" :loading="tableLoading">
    </Table>
    <div class="paging_style">
      <Page size="small" :total="total" :page-size="query.pageSize" show-total show-elevator show-sizer
        :current="query.pageNumber" @on-change="handleChangePage" :page-size-opts="pagesizeSetting"
        @on-page-size-change='changePageSize'></Page>
    </div>

    <createMeterBill  ref="createMeterBillModal" @on-success="reloadTable"></createMeterBill>
  </div>
</template>

<script>
import createMeterBill from './CreateMeterBill.vue'
// apis
import { pageElectricBill, deleteByBillId } from '@/api/invest/electricMeterBill'

import { toMoney } from '@/utils/wnumb_own'

export default {
  components: {
    createMeterBill
  },
  data () {
    return {
      pagesizeSetting: [15, 50, 100, 200, 500],
      query: {
        pageNumber: 1,
        pageSize: 15,
        billStatus: null, // 结算单状态(0:草稿,5:已结算)
        advertiserId: null,
        expectEndDate: '',
        expectStartDate: '',
        keyWord: ''
      },

      tableLoading: false,
      total: 0,
      tableData: [],
      tableColumns: [
        { title: '账单名称', key: 'billName' },
        { title: '对应合同', key: 'contractName' },
        { title: '付款单位', key: 'advertiserName' },
        { title: '预计付款日期', key: 'expectPayDate' },
        {
          title: '收款单总额',
          key: 'totalAmount',
          width: 120,
          align: 'right',
          render: (h, params) => {
            return h('span', {},
              toMoney(params.row.totalAmount))
          }
        },
        {
          title: '调差额',
          key: 'total',
          width: 120,
          align: 'right',
          render: (h, params) => {
            return h('span', {},
              toMoney(params.row.adjustAmount)
            )
          }
        },
        {
          title: '应付金额',
          key: 'amount',
          width: 150,
          align: 'right',
          render: (h, params) => {
            return h('strong', {
              attrs: {
                style: 'color:#44bd32'
              }
            },
            toMoney(params.row.actualAmount))
          }
        },
        {
          title: '状态',
          key: 'statusName',
          align: 'center',
          render: (h, params) => {
            if (params.row.billStatus === 0) {
              return h('tag', { props: { color: 'default' } }, params.row.billStatusName)
            } else {
              return h('tag', { props: { color: 'green', type: 'border' } }, params.row.billStatusName)
            }
          }
        },
        {
          title: '操作',
          align: 'center',
          render: (h, params) => {
            const buttons = [
              h('a', {
                style: { marginRight: '10px' },
                on: {
                  click: () => {
                    this.$store.commit('set_investment_elec_collection_pageType', 'detail')
                    this.$store.commit('set_investment_elec_collection_id', params.row.billId)
                  }
                }
              }, '查看详情')
            ]

            if (params.row.billStatus === 0) {
              buttons.push(h('a', {
                style: { color: '#ef4f4f' },
                on: {
                  click: () => {
                    this.confirmDeleteDebt(params.row.billId)
                  }
                }
              }, '删除'))
            }

            return h('div', buttons)
          }
        }
      ]
    }
  },
  created () {
    this.initBaseData()
  },
  methods: {
    initBaseData () {
      pageElectricBill(this.query).then(res => {
        this.tableData = res.list
        this.totalRow = res.totalRow
      })
    },
    handleSearch () {
      this.query.pageNumber = 1
      this.initBaseData()
    },
    reloadTable () {
      this.query.keyWord = ''
      this.handleSearch()
    },
    handleChangePage (curPage) {
      this.query.pageNumber = curPage
      this.initBaseData()
    },
    changePageSize (pageSize) {
      this.query.pageNumber = 1
      this.query.pageSize = pageSize
      this.initBaseData()
    },
    handleCreate () {
      this.$refs.createMeterBillModal.showModal()
    },
    confirmDeleteDebt (billId) {
      this.$Modal.confirm({
        title: '确定删除？',
        content: '<p>确定要删除该条数据，删除后将不可恢复！</p>',
        loading: true,
        onOk: () => {
          deleteByBillId({ billId }).then(res => {
            this.initBaseData()
            this.$Notice.success({ desc: '删除收款单成功。' })
            this.$Modal.remove()
          }).catch(() => {
            this.$Modal.remove()
          })
        }
      })
    }
  }
}
</script>
